import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="Branches" description="Manage station locations and amenities" />
      <TableSkeleton columns={6} />
    </>
  );
}
